module.exports = __webpack_public_path__ + "static/GetStarted-7-4c7a2808f361b3b25be8bfb77ec0d101.jpg";